import axios from "axios";
import {
  billingApiUrl,
  getBillingCancelUrl,
  getBillingSuccessUrl,
} from "../config/commrayUrls";

/** Billing host client — cookie auth only, never sends product Bearer token. */
const billingClient = axios.create({
  withCredentials: true,
});

export async function createBillingCheckoutSession(plan = "starter") {
  const payload = {
    plan,
    successUrl: getBillingSuccessUrl(),
    cancelUrl: getBillingCancelUrl(),
    success_url: getBillingSuccessUrl(),
    cancel_url: getBillingCancelUrl(),
  };

  const paths = [
    "/billing/create-checkout-session",
    "/create-checkout-session",
  ];

  let lastError = null;
  for (const path of paths) {
    try {
      return await billingClient.post(billingApiUrl(path), payload);
    } catch (error) {
      lastError = error;
      const status = error?.response?.status;
      if (status === 404) {
        continue;
      }
    }
  }

  throw lastError || new Error("Billing checkout endpoint was not found");
}
